<template>
  <div @click="handleClick" v-html="renderedHtml"/>
</template>

<script>
import MarkdownIt from 'markdown-it'
import mila from 'markdown-it-link-attributes'

let md = new MarkdownIt({ html: true })
md.use(mila, {
  attrs: {
    target: '_blank'
  }
})

export default {
  name: 'MarkdownText',
  props: {
    text: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renderedHtml() {
      return this.inline ? md.renderInline(this.text) : md.render(this.text)
    }
  },
  methods: {
    handleClick(evt) {
      if (evt.target && evt.target.tagName === 'A' && evt.target.href) {
        this.$emit('clicked:link', {
          text: evt.target.text,
          url: evt.target.href
        })
      }
    }
  }
}
</script>
